import React from 'react'
import './Footer.css'

function Footer() {
    return (
        <footer className='footer'>
                Developed with <span role='img' aria-label="hearth">❤️</span> by <a className='footer-link' href="https://github.com/simuratli">Simuratli</a>
        </footer>
    )
}

export default Footer
